<style lang="scss" scoped>
.sp-flatform-tip {
  background-color: #fffbe6;
  color: #777;
  font-size: 13px;
  height: 28px;
  line-height: 28px;
  padding: 0 6px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  .el-icon-info {
    margin-right: 2px;
    color: #faad14;
  }
}
</style>
<template>
  <div class="sp-flatform-tip">
    <i class="el-alert__icon el-icon-info" />
    {{ getTipText }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import otherData from '@/i18n/locale/other'
export default {
  name: 'SpPlatformTip',
  props: {
    weapp: {
      type: Boolean,
      default: true
    },
    h5: {
      type: Boolean,
      default: false
    },
    app: {
      type: Boolean,
      default: false
    },
    pc: {
      type: Boolean,
      default: false
    },
    alipay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getTipText() {
      const tips = []
      const platformList = [
          { value: 'weapp', title: this.lang == 'zh' ? '微信小程序':otherData.en['微信小程序'] },
          { value: 'h5', title: 'H5' },
          { value: 'app', title: 'APP' },
          { value: 'pc', title: this.lang == 'zh' ? 'PC网页版':otherData.en['PC网页版'] },
          { value: 'alipay', title: this.lang == 'zh' ? '支付宝小程序':otherData.en['支付宝小程序'] }
      ]
      platformList.forEach((item) => {
        if (this[item.value]) {
          tips.push(this.lang == 'zh' ?`${item.title}商城`:`${item.title}${otherData.en['商城']}`)
        }
      })
      return this.lang == 'zh' ? `该功能支持${tips.join('，')}。` : `${otherData.en['该功能支持']}${tips.join('，')}。`
    },
    ...mapGetters(['lang'])
  }
}
</script>
